import { notification } from "antd";
import moment from "moment-timezone";

const requestCacheService = {};

/*
    Ajuda a fazer cache de requisições. Usar apenas em requisições que não mudam quase nunca.
*/
requestCacheService.cacheRequest = async (
	key,
	callback,
	secondsToExpire = 86400,
) => {
	try {
		var data = JSON.parse(await localStorage.getItem("cache_" + key));
		var dateToExpire = moment(
			await localStorage.getItem("cache_" + key + "_expire"),
		);

		if (data && moment() < dateToExpire) return data;
	} catch {}

	data = await callback();
	await localStorage.setItem("cache_" + key, JSON.stringify(data));
	await localStorage.setItem(
		"cache_" + key + "_expire",
		moment().add(secondsToExpire, "seconds"),
	);

	return data;
};

/*
	Variante stale-while-revalidate: se há cache (mesmo velho), devolve NA HORA
	e revalida em background — quem passar onDadosFrescos recebe a resposta
	nova pra atualizar o estado. Sem cache, espera a rede como sempre.
	Invalidação continua a cargo do limparCache (mutações dos services e login).
*/
requestCacheService.cacheRequestSWR = async (key, callback, onDadosFrescos) => {
	let cacheado = null;
	try {
		cacheado = JSON.parse(localStorage.getItem("cache_" + key));
	} catch {}

	const revalidar = async () => {
		const frescos = await callback();
		try {
			localStorage.setItem("cache_" + key, JSON.stringify(frescos));
		} catch {
			// quota do localStorage cheia: segue funcionando sem cache
		}
		return frescos;
	};

	if (cacheado) {
		revalidar()
			.then((frescos) => {
				if (onDadosFrescos) onDadosFrescos(frescos);
			})
			.catch(() => {
				// revalidação em background falhou: fica com o stale
			});
		return cacheado;
	}

	return revalidar();
};

requestCacheService.limparCache = async (
	prekey = "",
	showNotification = false,
) => {
	const cacheKeys = Object.keys(localStorage).filter((key) =>
		key.includes("cache_" + prekey),
	);

	for (const key of cacheKeys) {
		await localStorage.removeItem(key);
	}

	if (!prekey && showNotification) {
		notification.success({ message: "Cache limpo com sucesso" });
	}
};

export default requestCacheService;
